//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/plugins/ant-design-public.js'
import { IGNORE_ROUTES } from "@/constants/analitics.js";

export default {
  name: 'PublicNewLayout',

  async fetch() {
    await this.$store.dispatch('async_fetch_data/fetchDataHeader')
  },


  head() {
    if (process.env.isStaging || IGNORE_ROUTES.includes(this.$route.name)) {
      return {
        link: [
          {
            rel: 'canonical',
            href: this.headCanonicalUrl
          }
        ]
      }
    }

    return {
      link: [
        {
          rel: 'canonical',
          href: this.headCanonicalUrl
        }
      ]
    }
  },

  computed: {
    pageLayoutBg() {
      const meta = this.$route.meta || {}
      if (meta.pageLayoutBg) {
        return meta.pageLayoutBg
      }
      for (let i = this.$route.matched.length - 1; i >= 0; i--) {
        const recordMeta = this.$route.matched[i].meta || {}
        if (recordMeta.pageLayoutBg) {
          return recordMeta.pageLayoutBg
        }
      }
      return null
    },
    pageLayoutStyle() {
      return this.pageLayoutBg ? { '--page-layout-bg': this.pageLayoutBg } : {}
    },
    hideFooter() {
      if (this.$route.name && this.$route.name.startsWith('ms-assistant_ai-dialogue')) {
        return true
      }
      return this.$route.query.search ? this.$route.name === 'search-pro' : false
    },
    headCanonicalUrl() {
      const url = this.$addServerPath('/');
      let canonicalUrl = url.split('/').slice(0, 3).join('/') + this.$route.path
      if (canonicalUrl[canonicalUrl.length - 1] === '/') {
        canonicalUrl = canonicalUrl.slice(0, canonicalUrl.length - 1);
      }
      return canonicalUrl
    }
  },
}
